<template>
  <v-container fluid>
    <div class="container">
      <!-- Alamat -->
      <v-row>
        <v-col cols="12">
          <div class="points d-flex justify-space-between">
            <div class="pointDtl">
              <v-icon>
                mdi-map-marker-radius
              </v-icon>
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold">Alamat Pengiriman</p>
                <p class=" ma-0 font-weight-bold">{{ this.alamat }}</p>
              </div>
            </div>
            <div class="my-auto">
              <v-icon @click="sheetAlamat = !sheetAlamat">mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <!-- tampilkan cara bayar jika non reward -->
          <div v-if="mode == $constant.NON_REWARD" class="points d-flex justify-space-between pa-5">
            <div class="pointDtl">
              <v-icon>
                mdi-wallet-bifold
              </v-icon>
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold">Virtual Account</p>
                <p>{{ this.va }}</p>
              </div>
            </div>
            <div class="my-auto">
              <span class="font-weight-bold mt-2 mr-4">BCA</span>
                <!-- <v-icon>mdi-chevron-right</v-icon> -->
            </div>
          </div>
          <div v-if="mode == $constant.REWARD">
            <div class="points d-flex justify-space-between">
              <div class="pointDtl">
                <v-img
                  max-height="40"
                  max-width="40"
                  src="@/assets/icon-color-coin.svg"
                ></v-img>
                <div>
                  <p class="text-subtitle-1 ma-0">M - Point Kamu</p>
                  <p class="totalPoint ma-0 font-weight-bold">{{ this.pointMekappin }}</p>
                </div>
              </div>
              <div class="my-auto">
                <router-link :to="`/${$constant.REWARD}`">
                <v-icon>mdi-chevron-right</v-icon>
              </router-link>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- List Produk -->
      <v-row>
        <v-col cols="12">
          <p class="totalPesanan ma-0 pa-0">Total Pesanan ({{ this.checkboxItemDetail.length }}):</p>
          <div v-if="this.checkboxItemDetail.length <= 3">
            <div v-for="item in this.productListMax3" :key="item.internalId">
              <div class="card mb-3">
                <v-img
                  :src="`data:image/png;base64,${item.iconSmall}`"
                  max-width="80"
                  max-height="80"
                  contain
                  lazy-src="@/assets/empty-img.png"
                ></v-img>
                <div class="ml-8">
                  <p class="title-card-produk pa-0 ma-0">{{ item.productName }}</p>
                  <p class="desc-card-produk pa-0 ma-0">{{  item.shoppingDate }}</p>
                  <div class="d-flex flex-row justify-space-between mt-3">
                    <!-- Jika non reward -->
                    <div v-if="mode == $constant.NON_REWARD">
                      <!-- KALAU ADA DISC -->
                      <div v-if="item.totalDiscount != null && item.totalDiscount != ''">
                        <span class="price mr-2">{{ item.price }}</span>
                        <span class="text-decoration-line-through mr-2">Rp. {{ humanFormat(item.priceProduct) }}</span>
                        <span class="totalDiscount">{{ item.totalDiscount }} Discount</span>
                      </div>
                      <!-- KALAU GA ADA -->
                      <div v-else>
                        <span class="price mr-2">{{ item.price }}</span>
                      </div>
                    </div>
                    <div v-if="mode == $constant.REWARD">
                      <div class="d-flex flex-row">
                        <v-img
                            max-height="20"
                            max-width="20"
                            src="@/assets/icon-color-coin.svg"
                        ></v-img>
                        <span class="ml-1" style="color: #FFA800;">{{ item.pointChange}} Poin</span>
                      </div>
                    </div>
                    <p class="text-right ma-0 pa-0">{{ item.quantity }} x</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="item in productList" :key="item.internalId">
              <div class="card mb-3">
                <v-img
                  :src="`data:image/png;base64,${item.iconSmall}`"
                  max-width="80"
                  max-height="80"
                  contain
                  lazy-src="@/assets/empty-img.png"
                ></v-img>
                <div class="ml-8">
                  <p class="title-card-produk pa-0 ma-0">{{ item.productName }}</p>
                  <p class="desc-card-produk pa-0 ma-0">{{  item.shoppingDate }}</p>
                  <div class="d-flex flex-row justify-space-between mt-3">
                    <!-- jika non reward -->
                    <div v-if="mode == $constant.NON_REWARD">
                      <!-- KALAU ADA DISC -->
                      <div v-if="item.totalDiscount != null && item.totalDiscount != ''">
                        <span class="price mr-2">{{ item.price }}</span>
                        <span class="text-decoration-line-through mr-2">Rp. {{ humanFormat(item.priceProduct) }}</span>
                        <span class="totalDiscount">{{ item.totalDiscount }} Discount</span>
                      </div>
                      <!-- KALAU GA ADA -->
                      <div v-else>
                        <span class="price mr-2">{{ item.price }}</span>
                      </div>
                    </div>
                    <div v-if="mode == $constant.REWARD">
                      <div class="d-flex flex-row">
                        <v-img
                            max-height="20"
                            max-width="20"
                            src="@/assets/icon-color-coin.svg"
                        ></v-img>
                        <span class="ml-1" style="color: #FFA800;">{{ item.pointChange}} Poin</span>
                      </div>
                    </div>
                    <p class="text-right ma-0 pa-0">{{ item.quantity }} x</p>
                  </div>
                </div>
              </div>
            </div>
            <v-btn>
              Semua Produk
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="mode == $constant.NON_REWARD" cols="12">
          <p class="rincian-title ma-0 pa-0">Rincian Pembayaran</p>
          <div class="d-flex flex-row justify-space-between">
            <div>
              <p>Sub Total Untuk Produk</p>
              <p>Biaya Pengiriman</p>
              <p>Pajak</p>
              <p class="total-bayar">Total Pembayaran</p>
            </div>
            <div>
              <p>{{ this.cartCheckoutSumView }}</p>
              <p>Rp. 0</p>
              <p>{{ this.ppn }} ( {{ this.totalPPN }} )</p>
              <p>{{ this.totalToBePaid }}</p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" v-if="mode == $constant.REWARD">
          <p class="rincian-title ma-0 pa-0">Rincian Pembayaran</p>
          <div class="d-flex flex-row justify-space-between">
            <div>
              <p class="total-bayar">Total Pembayaran:</p>
            </div>
            <div>
              <div class="d-flex flex-row">
                <v-img
                    max-height="20"
                    max-width="20"
                    src="@/assets/icon-color-coin.svg"
                ></v-img>
                <span class="ml-1" style="color: #FFA800;">{{ this.totalPoinChange}} Poin</span>
              </div>
              <!-- <p>{{ this.totalPoinChange }} Poin</p> -->
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn class="pesan" @click="goToAddOrder">
            {{ this.mode == $constant.REWARD ? 'Redeem' : 'Pesan' }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-bottom-sheet v-model="sheetAlamat" inset class="ma-0">
            <div class="bottomDialog">
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold text-center">
                  <span>
                    <v-icon>
                      mdi-map-marker-radius
                    </v-icon>
                  </span>
                  Alamat Pengiriman
                </p>
                <p class="totalPoint ma-0 font-weight-bold text-center">{{ this.alamat }}</p>
              </div>
            </div>
          </v-bottom-sheet>
        </v-col>
      </v-row>
      <v-row>
        <v-dialog
          v-model="successAddToCart"
          persistent
          max-width="450"
          max-height="350"
          width="100%"
        >
          <v-card class="pa-3">
            <div class="d-flex align-center justify-center mb-2">
              <v-img
                max-height="40"
                max-width="40"
                src="@/assets/acute.png"
              ></v-img>
            </div>
            <v-card-text class="text-center font-weight-bold">
              {{ $constant.MSG_ADD_ORDER }}
            </v-card-text>
            <v-card-text class="text-center">
              <v-spacer></v-spacer>
              <v-btn
                class="text-capitalize"
                small
                color="primary"
                elevation="0"
                @click="toDashboard"
              >
                Kembali ke Beranda
              </v-btn>
              <v-btn
                style="border-color: yellow"
                outlined
                class="text-capitalize ml-2"
                small
                text
                color="black"
                @click="toTransaction"
              >
                Lihat Transaksi
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      successAddToCart: false,
      cartCheckoutSumView: 0,
      totalPromoView: 0,
      cartPromoSum: 0,
      totalBayar: 0,
      totalProduk: 0,
      productList: [],
      productListMax3: [],
      totalPriceOriginal: 0,
      totalPricePPNOriginalDecimal: 0,
      totalPoinChange: 0,
      alamat: '',
      ppn: '',
      totalPPN: '',
      sheetAlamat: false,
      pointMekappin: 0,
      va: ''
    }
  },
  methods: {
    loadPoint(){
      this.getProfile().then((resp) => {
        console.log(resp)
        this.pointMekappin = resp.data.data.poin;
        this.va = this.va + resp.data.data.oid;
        this.alamat = resp.data.data.address;
        this.$store.commit("setProfile", { profileData: resp.data.data });
      });
    },

    toDashboard() {
      this.successAddToCart = false;
      this.$router.push(`/dashboard`);
    },
    toTransaction() {
      this.successAddToCart = false;
      this.$router.push(`/transactions/tab-OS_REWARD_TRANS`);
    },
    goToAddOrder(){
      let orderItemList = [];

      if (this.checkboxItemDetail.length > 3) {
        orderItemList = this.productList.map(function (itemId) {
          return { cartItemId: itemId.internalId};
       });
      }else{
        orderItemList = this.productListMax3.map(function (itemId) {
          return { cartItemId: itemId.internalId};
        });
      }

      if (this.mode == this.$constant.NON_REWARD) {
         //SEMENTARA PROMO DAN ADMIN FEE DI KOSONGAN
        this.addOrder({
          adminFeeAmt: 0,
          orderItemList: orderItemList,
          // programId: "",
          totalPrice: this.totalPriceOriginal,
          totalPromo: 0
        })
        .then((response) => {
          return this.$helpers.handleSuccess(response);
        })
        .then((response) => {
          console.log(response)
          if (response.status == 1) {
            this.successAddToCart = true;
          }
        })
      
      } else {
        this.addProductRewardOrder({
          orderItemList: orderItemList,
          poin: this.totalPoinChange
        })
        .then((response) => {
          return this.$helpers.handleSuccess(response);
        })
        .then((response) => {
          console.log(response)
          if (response.status == 1) {
            this.successAddToCart = true;
          }
        })
      }
    },
    handleCheckout() {
      this.refreshToken().then(() => {

        this.checkoutCart({
          listCartItemId: this.checkboxItemsChosenDetail,
          checkoutItems: this.checkoutItems,
          programId: this.promoChosen ? this.promoChosen : "",
        })
          .then((response) => {
            this.cartCheckoutSumView = response.data.totalPrice;
            this.totalBayar = response.data.totalToBePaid;
            this.cartPromoSum = response.data.totalPromo;
            this.totalPriceOriginal = response.data.totalPriceOriginal;
            this.totalPricePPNOriginalDecimal = response.data.totalPricePPNOriginal;
            this.ppn = response.data.ppn;
            this.totalPPN = response.data.totalPPN;
            return this.$helpers.handleSuccess(response);
            
          })
          .catch((err) => {
            this.$helpers.handleError(err);
          });
      });
    },
    handleCheckoutReward() {
      this.refreshToken().then(() => {
        this.checkoutCartReward({
          listCartItemId: this.checkboxItemsChosenDetail,
        })
          .then((response) => {
            this.totalPoinChange = response.data.totalPointChange;
            return this.$helpers.handleSuccess(response);
            
          })
          .catch((err) => {
            this.$helpers.handleError(err);
          });
      });
    },
    ...mapActions([
      "getVA",
      "addProductRewardOrder",
      "getProfile",
      "changeTitleApp",
      "getOrder",
      "addOrder",
      "addOrderReward",
      "payment",
      "refreshToken",
      "getCartList",
      "cancelOrder",
      "checkoutCart",
      "checkoutCartReward",
      "downloadPolisDealerCash",
      "submitDivoPolicy",
      "getNoPolis",
      "getProfile"
    ]),
  },
  props: ['mode'],
  async mounted() {

    if (this.mode == this.$constant.NON_REWARD) {
      if (this.checkboxItemsChosen.length > 0) {
        await this.handleCheckout();
      }
    }else{
      if (this.checkboxItemsChosenReward.length > 0) {
        await this.handleCheckoutReward();
      }
    }

    if (this.checkboxItemDetail.length > 3) {
      this.productList = this.checkboxItemDetail;
    }else{
      this.productListMax3 = this.checkboxItemDetail;
    }

    this.getVA().then((resp) => {
      this.va = resp.data.data.distributorVA;
    });

    this.loadPoint();
  },
  beforeDestroy() {
    // this.$store.state.checkboxItemDetail = [];
  },
  computed: {
    ...mapState([
      "profile",
      "checkoutItem",
      "checkboxItemDetail",
      "checkboxItemsChosenReward",
      "checkoutItems",
      "viewOrderdetails",
      "viewOrderItems",
      "viewOrderSum",
      "checkoutSum",
      "adminFeeSum",
      "adminFee",
      "promoChosen",
      "promoTotal",
      "totalToBePaid",
      "promoSum",
      "totalToBePaidSum",
      "promoChosenCode",
      "checkboxItemsChosenDetail",
      "checkboxItemsChosen",
      "programCode",
      "errorMessage",
    ]),
  }
}
</script>

<style src="./PurchaseDetailsNew.scss" lang="scss" />